import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/" className="footer-brand">DUBBAH</Link>
            <p>Free, private video dubbing in 14 languages</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3>Product</h3>
              <ul>
                <li><a href="https://petvids.s3.us-east-2.amazonaws.com/dubbah/Dubbah-Studio.dmg">Download for Mac</a></li>
                <li><Link to="/enterprise">Enterprise</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Legal</h3>
              <ul>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Contact</h3>
              <ul>
                <li><Link to="/contact">Get in touch</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} DUBBAH. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
